<template>
  <div class="detailContent">
      <div v-if="linkId!=-1" class="title" >{{form.title}}</div>
      <div v-else class="title1" >{{form.title}}</div>
      <div v-if="linkId!=-1" class="content ql-editor" v-html="form.content" ></div>
      <div v-if="linkId==-1" class="content" v-loading="isLoading" element-loading-text="数据提交中，请稍后..." >
        <textarea placeholder="请填写反馈内容" v-model.trim="opinion.content"></textarea>
        <div class="mobile"><div>手机号码：</div><input type="text" placeholder="请输入手机号" v-model.trim="opinion.mobile"></div>
        <div class="code">
          <div>验&nbsp;&nbsp;证&nbsp;&nbsp;码：</div>
          <input type="text" placeholder="请输入验证码" v-model.trim="opinion.code">
          <img :src="codeUrl" @click="refreshCaptcha">  
        </div>   
        <div class="submitDiv"> <input class="submitBtn" type="button" value="提交反馈"  :loading="isLoading" :disabled="isReset" @click="submitForm"></div>
      </div>
  </div> 
</template>
<style>
@import '../../styles/bottomLinkDetail.css';
@import '../../styles/md-toolbar.scss';
@import '../../styles/vue2-editor.scss';

</style>
<script>
  import { getBottomLink, addFeedback} from '@/api/bottomLink'
  import { getCaptchaImage } from '@/api/login'
  export default {
    components: {  },
    data () {
      return {
        isLoading: false,
        isReset: false,
        linkId:0,
        codeUrl:'',
        form:{
          title:''
        },       
        opinion:
        {
           mobile:'',
           content:'',
           code:'',
        },
        editAvatar: true
      }
    },
    computed: {    
    },
    mounted () {
      var id = this.$route.query.id; 
      if(id) 
      {
        this.linkId = parseInt(id)
      }
     if(this.linkId!=-1)
     {
        this._getBottomLink();
     }
     else
     {
        this.form.title="用户反馈";
        this.refreshCaptcha();     
     }
    },
    methods: {    
    refreshCaptcha()
    {    
      getCaptchaImage().then(response => {
          this.codeUrl ="data:image/jpg;base64," + response.data.result;
      }).catch(error => {     
        this.$message({
          message: '抱歉，服务器开了个小差！',
          type: 'error',
          customClass: 'c-msg',
          duration: 0,
          showClose: true
        })
      })
    },
    async _getBottomLink()
    {
       await getBottomLink({id:this.linkId}).then(res=>{
            this.form =  res.data.result   
        })
    },
    submitForm() {
          if(this.opinion.content=='')
          {
            this.$message({ message: '反馈内容不可为空', type: 'error', customClass: 'c-msg' })
            return;
          }
          if(this.opinion.mobile=='')
          {
            this.$message({ message: '手机号码不可为空', type: 'error', customClass: 'c-msg' })
            return;
          }
          var myreg=/^[1][3,4,5,7,8][0-9]{9}$/;
          if(!myreg.test(this.opinion.mobile))
          {
            this.$message({ message: '手机号码格式不正确', type: 'error', customClass: 'c-msg' })
            return;
          }       
           if(this.opinion.code==''||this.opinion.code==undefined||this.opinion.code==null)
          {
            this.$message({ message: '验证码不可为空', type: 'error', customClass: 'c-msg' })
            return;
          }
         
          this.isLoading = true
        
          addFeedback(this.opinion).then(response => {
            this.isLoading = false
            if (response.data.success === true) { 
              this.opinion.mobile='';
              this.opinion.content='';
              this.$message({message: '反馈成功。', type: 'success', customClass: 'c-msg' })
            } else {
              var msg='';
              if(response&&response.data&&response.data.error&&response.data.error.message)
              {
                 msg =',原因:'+response.data.error.message;
              }
              this.$message({ message: '反馈失败'+msg,type: 'error', customClass: 'c-msg', duration: 5000})
            }
          }).catch(error => {
            this.isLoading = false           
            this.$message({ message: '反馈失败', type: 'error',customClass: 'c-msg', duration: 1000, showClose: true })          
          })
    },
  
    created () {
    
    
      
    },

  }
}
</script>



// WEBPACK FOOTER //
// detail.vue?0a9272fe